import { SVGProps } from 'react';

const ParkingPass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 14v6h20V4H2v6c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 2 14Zm11.389-7H9.5v10h2.222v-3.333h1.667c.926 0 1.713-.324 2.361-.973.648-.648.972-1.435.972-2.36 0-.927-.324-1.714-.972-2.362C15.102 7.324 14.315 7 13.389 7Zm.111 4.444h-1.778V9.222H13.5c.306 0 .567.109.785.327.217.217.326.479.326.784 0 .306-.109.567-.326.785a1.07 1.07 0 0 1-.785.326Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ParkingPass;
